// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__l2RoY","header":"ClearentDisclaimer_header__3BE79","inner":"ClearentDisclaimer_inner__VHc01"};